import React from 'react';
import { Zoom } from 'react-reveal';

const OurGainCart = ({ gain }) => {
    const { title, gainLogo, numberCount } = gain;
    return (
        <div className='col-lg-6 col-md-6 col-sm-12 col-12'>
            <Zoom>
                <div className="shadow-lg d-flex rounded align-items-center p-2">
                    <div className="gainlogo">
                        <img src={gainLogo} alt='logo' className='img-fluid' />
                    </div>
                    <div className="gain-title ps-3">
                        <h2 className='fw-bold fs-3'>{title}</h2>
                        <h6 className='fs-4'>{numberCount}</h6>
                    </div>
                </div>
           </Zoom>
        </div>
    );
};

export default OurGainCart;